document.addEventListener('DOMContentLoaded', function () {   
    $.validator.unobtrusive.adapters.addBool("booleanrequired", "required");
});